import React, {useState, useEffect} from "react"
import { useStore } from "../../teafuljs/store"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import IconButton from "@material-ui/core/IconButton"
import CloseIcon from "@material-ui/icons/Close"
import VideoIcon from "@material-ui/icons/OndemandVideo"
import DialogContent from "@material-ui/core/DialogContent"
import PlayCircleFilled from "@material-ui/icons/PlayCircleFilled"
import KeyPassages from "./../../data/newKeyPassages.json"
import Foundational from "./../../../static/images/Foundational.png"
import Celebration from "./../../../static/images/Celebration.png"
import Communication from "./../../../static/images/Communications.png"
import Economics from "./../../../static/images/Economics.png"
import Education from "./../../../static/images/Education.png"
import Family from "./../../../static/images/Family.png"
import Government from "./../../../static/images/Government.png"
import Religion from "./../../../static/images/Religion.png"
import GetSegment from "../../scripts/NavigateToSegment"
import scrollToElement from "scroll-to-element"
import { getTranslation } from "../../scripts/getTranslation"
import getVersionVerse from "../../scripts/getVersionVerse"
import useGoogleSheets from "use-google-sheets"

import { makeStyles } from "@material-ui/core/styles"
import SphereViewVideo from "../SphereViewVideos"
import SphereViewQuestions from "../SphereViewQuestions"
import CheckMark from "../CheckMark"

const useStyles = makeStyles(theme => ({
  typography: {
    padding: theme.spacing(2),
    fontSize: "small",
    color: "white",
  },
  definition: {
    fontWeight: "bold",
  },
  dialogRef: {
    color: "grey",
    fontSize: "80%",
    textAlign: "center",
    marginBottom: "-15px",
  },
  dialogHeader: {
    width: '50vw',
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "-10px",
  },
  logo: {
    height: "30px",
    width: "auto",
  },
  SVicons: {
    height: "50px",
    width: "50px",
    marginRight: "5px",
    marginBottom: "5px",
  },
  dialogTitle: {
    display: "flex",
    flexWrap: "nowrap",
    justifyContent: "space-between",
  },
  navButtons: {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    textAlign: "center",
  },
  icon: {
    backgroundColor: "white",
    color: "#19857b",
    borderRadius: "25px",
    fontSize: "30px",
  },
  nextNum: {
    fontSize: "50%",
    color: "grey",
    margin: 0,
    textAlign: "center",
    lineHeight: "120%",
  },
  nextTitle: {
    fontSize: "40%",
    color: "grey",
    margin: 0,
  },
  nextRef: {
    fontSize: "45%",
    color: "grey",
    margin: 0,
  },
  link: {
    position: "relative",
    width: "40%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  category: {
    position: "relative",
    width: "100%",
    color: "grey",
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: "80%",
    textAlign: "center",
  },
  title: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    fontWeight: "bold",
    textAlign: "center",
  },
  closeButtonHolder: {
    margin: 0,
    padding: 0,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  videoIconDiv: {
    display: "inline-block",
    marginLeft: 10,
    verticalAlign: "middle",
  },
  dialogContent: {
    margin: 0,
    padding: 0,
  },
  subheader: {
    margin: "5px 20px"
  },
  checkmarkdiv: {
    position: "relative",
    width: "75px",
    height: '75px',
    display: "flex",
    justifyContent: "center",
    margin: "20px auto",
  }
}))

const SphereViewDialog = ({
  sphereViewDialog,
  newSphereViewDialog,
  onClose,
}) => {
  const translations = useStore.translations()[0]
  const AvailableContent = useStore.AvailableContent()[0]
  const language = useStore.language()[0]
  const version = useStore.version()[0]
  const versification = useStore.versification()[0]
  const [currentSegmentID, setCurrentSegmentID] = useStore.currentSegmentID();
  const [refID, setRefID] = useStore.refID();
  const setSearchID = useStore.setSearchID()[1]
  const [history, setHistory] = useStore.history();
  const classes = useStyles()
  const [showCatVideo, setShowCatVideo] = useState(false);
  const { content } = sphereViewDialog
  const { cat, fullref, id, mainSphere, number, ref, spheres, title, standardRef } = content
  // const hasVideo = mainSphere === "Education" || mainSphere === "Family"
  const isStandardVersification =
    AvailableContent.content[language].versions[version]
      .versification === "standard"
  const [hasRowData, setHasRowData] = useState(false)
  const { data, loading, error } = useGoogleSheets({
    apiKey: "AIzaSyAb_P06-faYkzrsHqYvF7us6kBdfyIpY6M",
    sheetId: "1dHiHr64uZ8pFUjY_mDqOD8SAQtdTxNtKSDjN4AFcy4U",
    sheetsNames: [language],
  })

  const hasData = sphereId => {
    if (data && data[0]) {
      console.log(sphereId, "data[0].data", data[0].data)
      const rows = data[0].data
      const rowData = rows.find(b => b["ID"] === sphereId)
      const boolean = Object.keys(rowData).length > 0
      setHasRowData(boolean)
      return
    }
    setHasRowData(false)
    return
  }


  function getSphereLogo(sphere) {
    switch (sphere) {
      case "FOU":
        return <img src={Foundational} className={classes.logo} alt="FOU" />
      case "CEL":
        return <img src={Celebration} className={classes.logo} alt="CEL" />
      case "COM":
        return <img src={Communication} className={classes.logo} alt="COM" />
      case "ECO":
        return <img src={Economics} className={classes.logo} alt="ECO" />
      case "EDU":
        return <img src={Education} className={classes.logo} alt="EDU" />
      case "FAM":
        return <img src={Family} className={classes.logo} alt="FAM" />
      case "GOV":
        return <img src={Government} className={classes.logo} alt="GOV" />
      case "REL":
        return <img src={Religion} className={classes.logo} alt="REL" />
      default:
        return null
    }
  }
  function pad(str, max) {
    str = str.toString()
    return str.length < max ? pad("0" + str, max) : str
  }

  const getNewKeyPassage = num => {
    const nextNum = pad(parseInt(number) + num, 2)
    const newKP = `${spheres[0]}-${nextNum}`
    if (!KeyPassages[newKP]) {
      return "none"
    }
    const refInfo = KeyPassages[newKP].ref.split("-")
    const isAvailable =
      AvailableContent.content[language][version][
        refInfo[0]
      ] &&
      AvailableContent.content[language][version][refInfo[0]]
        .segments.length > 1
        ? true
        : false
    if (isAvailable) {
      return KeyPassages[newKP]
    } else {
      return false
    }
  }

  const availableKP = direction => {
    let i = direction === "prev" ? -1 : 1
    while (!getNewKeyPassage(i)) {
      if (direction === "prev") {
        i = i - 1
      } else {
        i = i + 1
      }
    }
    if (getNewKeyPassage(i) === "none") {
      return null
    } else {
      return getNewKeyPassage(i)
    }
  }

  function search(RefID) {
    setHistory([
      {
        page: window.location.pathname,
        language: language,
        version: version,
        segment: currentSegmentID,
        scrollY: window.scrollY,
      },
      ...history,
    ])
    const refInfo = RefID.split("-")
    const segment = GetSegment(
      refInfo[0],
      parseInt(refInfo[1]),
      parseInt(refInfo[2])
    )
    if (currentSegmentID === segment) {
      newSphereViewDialog({ open: false, content: {} })
      console.log("same page navigation: did it work?")
      samePageNavigation(`ref-${RefID}`)
    } else {
      newSphereViewDialog({ open: false, content: {} })
      console.log("Did it navigate?")
      setCurrentSegmentID(segment)
      setRefID(RefID)

    }
  }

  function samePageNavigation(id) {
    const element = document.querySelectorAll(`[verseref=${id}]`)[0]
    scrollToElement(element, {
      offset: -65,
      ease: "inOutCube",
      duration: 1500,
    })
    console.log("same page navigation")
    setSearchID("")
  }

  useEffect(() => {
    console.log("useEffect", data, !hasRowData, data && !hasRowData)
    if (data && !hasRowData) {

      hasData(id)
    }
   },[data])

  console.log('hasData', hasRowData)
  return (
    <Dialog
      id={`sphere_${spheres[0]}`}
      open={sphereViewDialog.open}
      onClose={() => newSphereViewDialog({ open: false, content: {} })}
    >
      <DialogTitle id={`sphere_kp_${spheres[0]}_${number}`}>
        <div className={classes.dialogHeader}>
          {getSphereLogo(spheres[0])}
          <p className={classes.dialogRef}>
            {getTranslation(
              translations,
              language,
              "UI",
              `menu_sphere_${spheres[0].toLowerCase()}`
            )}{" "}
            #{number}
          </p>
          <div className={classes.closeButtonHolder}>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      </DialogTitle>
      <DialogContent className={classes.dialogContent} dividers>
        <div className={classes.subheader}>
          <div
            className={classes.category}
            onClick={hasRowData ? () => setShowCatVideo(!showCatVideo) : null}
          >
            {getTranslation(translations, language, "KeyPassages", cat)}
            {/* <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          > */}
            {hasRowData ? (
              <div
                className={classes.videoIconDiv}
                onClick={() => setShowCatVideo(!showCatVideo)}
              >
                {!showCatVideo ? <VideoIcon /> : <CloseIcon />}
              </div>
            ) : null}
            {/* </IconButton> */}
          </div>
        </div>
        {showCatVideo ? (
          <SphereViewVideo language={language} version={version} id={cat} />
        ) : null}
        <div className={classes.subheader}>
          <div className={classes.title}>
            {getTranslation(
              translations,
              language,
              "KeyPassages",
              title
            ).toUpperCase()}
          </div>
        </div>
        <div className={classes.category}>
          {`${getTranslation(
            translations,
            language,
            "Books",
            `abbrev_${ref.split("-")[0].trim()}`
          )} ${
            isStandardVersification && standardRef
              ? standardRef.substring(4)
              : fullref.substring(4)
          }`}
        </div>
        {hasRowData ? (
          <SphereViewVideo language={language} version={version} id={id} />
        ) : null}
        {hasRowData ? (
          <SphereViewQuestions
            language={language}
            id={id}
            translations={translations}
          />
        ) : null}
        <div className={classes.checkmarkdiv}>
          <CheckMark language={language} version={version} id={id} />
        </div>
        <div className={classes.subheader}>
          <div className={classes.navButtons}>
            <div
              className={`${classes.link} ${classes.left}`}
              onClick={
                availableKP("prev")
                  ? () =>
                      search(
                        getVersionVerse(
                          versification[version],
                          availableKP("prev").ref
                        )
                      )
                  : null
              }
            >
              {availableKP("prev") ? (
                <React.Fragment>
                  {/* <IconButton> */}
                  <PlayCircleFilled
                    className={classes.icon}
                    style={{ transform: "rotate(180deg)" }}
                  />
                  {/* </IconButton> */}
                  <p className={classes.nextNum}>
                    #{availableKP("prev").number}
                    <br />
                    {`${getTranslation(
                      translations,
                      language,
                      "Books",
                      `abbrev_${availableKP("prev")
                        .ref.split("-")[0]
                        .trim()}`
                    )} ${
                      isStandardVersification && availableKP("prev").standardRef
                        ? availableKP("prev").standardRef.substring(4)
                        : availableKP("prev").fullref.substring(4)
                    }`}
                  </p>
                </React.Fragment>
              ) : null}
            </div>
            <div
              className={`${classes.link} ${classes.right}`}
              onClick={
                availableKP("next")
                  ? () =>
                      search(
                        getVersionVerse(
                          versification[version],
                          availableKP("next").ref
                        )
                      )
                  : null
              }
            >
              {availableKP("next") ? (
                <React.Fragment>
                  {/* <IconButton> */}
                  <PlayCircleFilled className={classes.icon} />
                  {/* </IconButton> */}
                  <p className={classes.nextNum}>
                    #{availableKP("next").number}
                    <br />
                    {`${getTranslation(
                      translations,
                      language,
                      "Books",
                      `abbrev_${availableKP("next")
                        .ref.split("-")[0]
                        .trim()}`
                    )} ${
                      isStandardVersification && availableKP("next").standardRef
                        ? availableKP("next").standardRef.substring(4)
                        : availableKP("next").fullref.substring(4)
                    }`}
                  </p>
                </React.Fragment>
              ) : null}
              {/* <p className={classes.nextTitle}>{availableKP('next').title}</p> */}
              {/* <p className={classes.nextRef}>{availableKP('next').fullref}</p> */}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default SphereViewDialog
// const SourceViewDialog = (props) => {
//   const classes = useStyles();
//   return (
//     <Dialog
//       maxWidth='lg'
//       open={props.sourceViewDialog.open}
//       onClose={() => props.newSourceViewDialog({open: false, content: {}})}
//     >
//       <DialogTitle>
//         <div className={classes.dialogTitle}>
//           <img src={SVBLogo} className={classes.SVicons} alt="SourceView Logo" />
//           <div className={classes.title}>
//             <Typography variant="h5">SourceView Info</Typography>
//           </div>
//         </div>
//       </DialogTitle>
//       <DialogContent dividers className={classes.dialogContent}>
//         <SourceViewInfo content={props.sourceViewDialog.content} close={() => props.newSourceViewDialog({open: false, content: {}})}/>
//       </DialogContent>
//     </Dialog>
//   )
// }

// export default SourceViewDialog;
